(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-info.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-info.js');
"use strict";


const {
  NameInput,
  GreetingsInput,
  PersonalGreetingInput
} = svs.tickets_giftshop.gift.giftform.components;
const {
  NAME,
  GREETING,
  PERSONAL_GREETING
} = svs.tickets_giftshop.constants.names;
const {
  GREETINGS_MAX
} = svs.tickets_giftshop.constants.form;
const PersonalInfo = React.forwardRef((_ref, ref) => {
  let {
    onInputChange,
    personalGreeting,
    name,
    greeting,
    greetingMaxLength = GREETINGS_MAX
  } = _ref;
  const header = 'Skriv en hälsning';
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-body"
  }, React.createElement("h2", {
    className: "tg-form-header h2 u-text-center",
    ref: ref
  }, header), React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(PersonalGreetingInput, {
    name: PERSONAL_GREETING,
    onInputChange: onInputChange,
    value: personalGreeting
  }), React.createElement(NameInput, {
    name: NAME,
    onChange: onInputChange,
    value: name
  }), React.createElement(GreetingsInput, {
    maxLength: greetingMaxLength,
    name: GREETING,
    onChange: onInputChange,
    value: greeting
  }))));
});
svs.tickets_giftshop.gift.giftform.components.PersonalInfo = PersonalInfo;

 })(window);